<template>
  <div
  >
    <div class="beneficary-details-page">
      <div class="flex-center">
        <img
          class="membership-user border-round"
          :src="this.getImagePath() + 'users/user_' + this.person.id + '.png'"
          @error="($event.target.src=require('@/assets/images/offer_0.svg'))" 

        />
        <person-contact :person="this.person" @addFriend="addFriend()" :isFriend="isFriend"/>
      </div>
      <br clear="all" />
      <div>
        <div class="left">
          <h1>{{ $t("personsOffersTitle") }}</h1>
          <p>{{ $t("personsOffersTitle") }}</p>
        </div>
        <div class="right">
          <div class="align-items-start">
              <small>{{ $t("sortFilter") }}</small>
              <select
                @change="sortByChanged"
                v-model="this.sortBySelected"
              >
                <option v-for="(entry, index) in sortBy" :key="index">
                  {{ $t("sortBy_" + entry) }}
                </option>
              </select>
          </div>
        </div>
      </div>
      <br clear="all" />
      <!-- <div
        v-if="this.dedicatedOffers === null"
        id="modal_popup_loading-beneficiary"
        class="modal-popup"
      >
        <div class="modal-popup-content">
          <img src="@/assets/images/loading.gif" />
          <p v-html="$t('loadingPopupMessage')"></p>
        </div>
      </div> 
    v-else -->
      <div >
        <offer-case
          v-for="(entry, index) in dedicatedOffers"
          :key="index"
          :offer="entry"
          :user="user"
          @showDetails="openOfferDetails"
        />
      </div>
    </div>
    <offer-details-popup :offer="this.selectedOffer" :user="this.user"  />
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_info', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.offersError">
          <p v-html="$t('error_' + this.offersError.code)"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonContact from "@/components/fragments/PersonContact.vue";
import OfferDetailsPopup from "@/components/fragments/OfferDetailsPopup.vue";
import OfferCase from "@/components/fragments/OfferCase.vue";
import httpServiceCustomer from "@/http/http-customer.js";
import Cookies from "js-cookie";

export default {
  components: { PersonContact, OfferDetailsPopup, OfferCase },
  props: {
    user:Object,
    person: Object,
    isFriend: Boolean
  },
  data() {
    return {
      categorySelected: "ALL",
      categories: ["ALL", "IT", "MARKETING"],
      sortBy: ["NEW", "OLD"],
      sortBySelected: "NEW",
      sortField: "valstdate",
      sortDirection: "desc",
      perPage: 10000,
      currentPage: 1,
      dedicatedOffers: null,
      offersError: null,
      selectedOffer: null,
    };
  },
  methods: {
    getDedicatedOffers() {
      this.dedicatedOffers = null;
      var offersData = "?person=" + this.person.id;
      if (this.categorySelected !== "ALL") {
        offersData += "&category=" + this.categorySelected;
      }
      offersData +=
        "&per_page=" +
        this.perPage +
        "&page=" +
        this.currentPage +
        "&sort=" +
        this.sortDirection;
      if (this.sortDirection === "desc") {
        offersData += "&desc=" + this.sortField;
      } else {
        offersData += "&asc=" + this.sortField;
      }
      httpServiceCustomer.customerService
        .searchOffers(offersData, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.offersError = {
            code: error.response.data,
            description: "Error fetching offers",
          };
        })
        .then((response) => {
          if (response.status == 200) {
            this.dedicatedOffers = response.data;
            // this.invoicesCount = response.headers["x-up-count"]; //["Content-Length"];
          } else if (response.status == 400 || response.status == 403) {
            this.offersError = {
              code: response.data,
              description: "Error fetching offers",
            };
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.offersError = { description: response.description };
            this.showModalPopup("modal_popup_info", true);
          }
        });
    },
    categoryChanged() {
      this.getDedicatedOffers();
    },
    openOfferDetails(offer) {
      this.selectedOffer = offer;
      this.showModalPopup("modal_popup_offer", true);
    },
    sortByChanged() {
      switch (this.sortBySelected) {
        case "NEW":
          this.sortField = "datime";
          this.sortDirection = "desc";
          break;
        case "OLD":
          this.sortField = "datime";
          this.sortDirection = "asc";
          break;
        default:
          this.sortField = "datime";
          this.sortDirection = "desc";
      }
    },
    addFriend() {
      this.$emit("addFriend", this.person.id);
    },
  },
  created() {
    this.getDedicatedOffers();
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style scoped>
.flex-center {
  display: flex;
  align-items: center;
}
.clear-none {
  clear: none;
}

.beneficary-details-page .left {
  display: inline-block;
  width: 50%;
}

.beneficary-details-page .right {
  display: inline-block;
  width: 50%;
}

@media (max-width: 1003px) {
  .beneficary-details-page {
    width: 95%;
    margin: 0 auto;
  }
}
</style>
